<template lang="html">
  <div
    class="modal"
    :class="{'is-open': isOpen}"
    @click="close">
    <div class="modal-container" @click.stop="preventClick">

      <div class="modal-header">
        <h2
          v-if="title"
          class="modal-title">
          {{title}}
        </h2>
        <button
          v-for="(button, index) in headerActions"
          :key="index"
          type="button"
          class="button is-small"
          :class="button.classList"
          v-on:click="getButtonAction(button)"
        >{{button.title}}</button>
        <button
          type="button"
          class="button is-square is-rounded is-xsmall is-gray-100 modal-close"
          v-on:click="close">
          <span class="css-icon is-close"></span>
        </button>
      </div>

      <div class="modal-content">
        <slot></slot>
      </div>

      <div class="modal-footer">

        <button
          type="button"
          class="button is-small is-gray-400"
          v-on:click="close">{{ $t('components.modal.close') }}</button>
        <div>
          <button
            v-for="(button, index) in footerActions"
            :key="index"
            type="button"
            class="button is-small"
            :class="button.classList"
            v-on:click="getButtonAction(button)"
          >{{button.title}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">

import { eventHubMixin } from '@/mixins/event';

export default {
  name: 'Modal',
  mixins: [eventHubMixin],
  components: {
  },
  filters: {
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
      required: false,
    },
    headerActions: {
      type: Array,
      default: () => [],
      required: false,
    },
    footerActions: {
      type: Array,
      default: () => [],
      required: false,
    },
  },
  mounted() {
    this.eventHub.$on(`modal:${this.name}:close`, () => this.close());
    this.eventHub.$on(`modal:${this.name}:open`, data => this.open(data));
  },
  data() {
    return {
      isOpen: false,
      data: null,
    };
  },
  methods: {
    open(data) {
      this.data = (data) || null;
      this.isOpen = true;
    },

    close() {
      this.isOpen = false;
    },

    getButtonAction(button) {
      this.eventHub.$emit(button.action);
    },
    preventClick() {
      this.eventHub.$emit('document:click');
    },
  },
  computed: {
  },
};
</script>
